import {
  PHASES,
  PHASE_COPY,
  ROLES,
  defaultVoiceSettings,
  getRolePreset,
  type PublicPlayer,
  type RoomState,
} from "@ma-soi/game-core";

const NAMES = [
  "An", "Bình", "Chi", "Dũng", "Giang", "Hà", "Khoa", "Lan",
  "Minh", "Ngọc", "Phúc", "Quỳnh", "Sơn", "Thảo", "Uyên", "Việt",
] as const;

export const UI_PREVIEW_PHASES = PHASES.map((phase) => ({ phase, ...PHASE_COPY[phase] }));
export const UI_PREVIEW_ROLES = ROLES;

export function fixturePlayers(count: 6 | 12 | 16): PublicPlayer[] {
  return NAMES.slice(0, count).map((name, index) => ({
    uid: `preview-${index + 1}`,
    name,
    normalizedName: name.toLocaleLowerCase("vi"),
    seat: index + 1,
    ready: index !== 3,
    alive: index !== 4,
    isHost: index === 0,
    muted: false,
    connected: index !== 5,
    joinedAtMs: 1_780_000_000_000 + index,
    revealedRole: index === 4 ? "VILLAGER" : null,
  }));
}

export function fixtureRoom(patch: Partial<RoomState> = {}): RoomState {
  const maxPlayers = patch.settings?.maxPlayers ?? 16;
  return {
    roomCode: "DEV016",
    hostId: "preview-1",
    status: "playing",
    gameId: "preview-game",
    phase: "DISCUSSION",
    phaseId: 9,
    dayNumber: 2,
    paused: false,
    phaseEndsAtMs: Date.now() + 5_000,
    pausedRemainingMs: null,
    playerCount: 16,
    settings: {
      title: "Làng Trăng Đỏ",
      visibility: "private",
      maxPlayers,
      discussionSeconds: 180,
      votingSeconds: 45,
      nightActionSeconds: 40,
      revealRoleOnDeath: false,
      ghostChatEnabled: true,
      guardRepeatTarget: false,
      disabledSpecialRole: null,
      voiceSettings: defaultVoiceSettings(),
      roleCounts: getRolePreset(maxPlayers),
      ...patch.settings,
    },
    winner: null,
    lastDeaths: [],
    voteResult: null,
    ...patch,
  };
}
